// Banners Intances
const banners = document.querySelector('.banners.image');
const slides = document.querySelectorAll('.splide__slide');
if(banners && slides.length){

    // Order Slides Item to First Place
    const itemToFirst = document.querySelector('.banners.image li[data-order="1"]');
    if(itemToFirst){
        const list = document.querySelector('.banners.image .splide__list');
        list.prepend(itemToFirst);
    }

    if(window.isDevice.Mobile){
        new Splide('.banners.image', {
            arrows: false,
            autoplay: true,
            interval: 4000,
            rewind: true
        }).mount();
    }else{
        var splide_banners = new Splide('.banners.image', {
            focus: 'center',
            type: slides.length === 1 ? 'slide' : 'loop',
            perPage: 1,
            trimSpace: false,
            arrows: slides.length === 1 ? false : true,
            width: '82%',
            autoplay: true,
            interval: 4000,
            rewind: true
        });
        splide_banners.mount();
    }
}